/** Display name of the non-deletable Gstar system account (case-insensitive). */
const GSTAR_SYSTEM_USER_FULL_NAME = 'gstar system user';

/** Blocks delete for the reserved Gstar system user row. */
export function isGstarSystemUser(row: { fullName?: string }): boolean {
  const normalized = (row.fullName ?? '').trim().toLowerCase();
  return normalized === GSTAR_SYSTEM_USER_FULL_NAME;
}
